import React from "react";
import {
  Box,
  Chip,
  MenuItem,
  OutlinedInput,
  Select,
  FormControl,
} from "@mui/material";
import { Field } from "formik";

const MultipleSelectChip = ({ field, form, options, placeholder, renderLabel }) => {
  const { setFieldValue, values } = form;
  const selectedValues = values[field.name] || [];

  const handleDelete = (valueToRemove) => {
    // Remove the value from the array and update Formik state
    const newValues = selectedValues.filter((item) => item !== valueToRemove);
    setFieldValue(field.name, newValues);
  };

  return (
    <FormControl variant="outlined" sx={{ width: "100%" }}>
      {renderLabel && renderLabel(field.label)}
      <Field
        as={Select}
        labelId={`${field.name}-label`}
        id={field.name}
        name={field.name}
        multiple
        value={selectedValues}
        onChange={(event) => {
          const {
            target: { value },
          } = event;
          // Convert value to array if it's a string
          setFieldValue(
            field.name,
            typeof value === "string" ? value.split(",") : value
          );
        }}
        input={
          <OutlinedInput
            id={field.name}
            // label={placeholder}
            // inputProps={{ "aria-label": placeholder }}
          />
        }
        renderValue={(selected) => (
          <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
            {selected.map((value) => (
              <Chip
                key={value}
                label={value}
                onDelete={() => handleDelete(value)}
                sx={{
                  height: "24px", // Adjust height of the chip
                  fontSize: "0.75rem", // Adjust font size if needed
                }}
              />
            ))}
          </Box>
        )}
        sx={{
          "& .MuiSelect-select": {
            padding: "8px",
          },
          "& .MuiOutlinedInput-notchedOutline": {
            borderRadius: "4px",
          },
        }}
      >
        <MenuItem value="" disabled>
          <em>{placeholder}</em>
        </MenuItem>
        {options.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Field>
    </FormControl>
  );
};

export default MultipleSelectChip;
